import {Component, OnDestroy, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectorRef} from '@angular/core';
import {faHeadphones, faSyncAlt} from '@fortawesome/free-solid-svg-icons';
import {SuggestionService} from 'app/blocks/service/api/suggestion.service';
import {AIInputService, InputType} from 'app/blocks/service/ai-input.service';
import {Subject} from 'rxjs';
import {RoleService} from 'app/blocks/service/api/role.service';

@Component({
    selector: 'ai-product',
    template: `
        <span *ngIf="roleEnabled">
            <span *ngIf="!this.loading">
                <fa-icon
                    [spin]="this.isRecording"
                    style="font-size: 24px;"
                    [icon]="faHeadphones"
                    (click)="toggleRecording()"
                    class="ml-12"
                    nz-tooltip
                    nzTooltipTitle="Voice"></fa-icon>
            </span>
            <span *ngIf="this.loading">
                Getting Suggestions
                <fa-icon [icon]="faUploading" [spin]="true"></fa-icon>
            </span>
        </span>
    `
})
export class AIProductComponent implements OnInit, OnDestroy, AfterViewInit {
    private _unsubscribeAll = new Subject<void>();
    private mediaRecorder: MediaRecorder | null = null;
    isRecording = false;
    loading = false;

    faUploading = faSyncAlt;
    faHeadphones = faHeadphones;
    roleEnabled = true;

    @Input() onProductSuggestion: (data: any) => void;

    constructor(
        private suggestionService: SuggestionService,
        private roleService: RoleService
    ) {
        this.roleService.roleSettings.subscribe((roleSettings) => {
            if (roleSettings['ai-feature'] != null) {
                this.roleEnabled = roleSettings['ai-feature'];
            }
        });
    }

    ngOnInit(): void {}

    ngAfterViewInit(): void {}

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    toggleRecording() {
        if (this.isRecording) {
            this.stopRecording();
        } else {
            this.startRecording();
        }
    }

    startRecording() {
        this.isRecording = true;
        navigator.mediaDevices
            .getUserMedia({audio: true})
            .then((stream) => {
                this.mediaRecorder = new MediaRecorder(stream);
                this.mediaRecorder.addEventListener('dataavailable', this.audioEvent.bind(this));
                this.mediaRecorder.start();
            })
            .catch((error) => console.error('Error accessing the microphone', error));
    }

    stopRecording() {
        this.isRecording = false;
        this.mediaRecorder?.stop();
    }

    audioEvent(event) {
        this.loading = true;
        const audioFile = new File([event.data], 'data.audio', {type: event.data.type});
        this.suggestionService
            .getSuggestion(audioFile, 'products', InputType.VOICE)
            .then((response) => {
                const productSuggestions = [];
                const allOptions = [];
                for (const suggestion of response.suggestion.items) {
                    if (suggestion.ids.length === 0) {
                        continue;
                    }

                    for (let i = 0; i < suggestion.ids.length; i++) {
                        if (allOptions.find((option) => option.id === suggestion.ids[i])) {
                            continue;
                        }
                        allOptions.push({
                            id: suggestion.ids[i],
                            handheldDescription: suggestion.names[i],
                            statementDescription: suggestion.names[i],
                            code: suggestion.codes[i]
                        });
                    }

                    productSuggestions.push({
                        orderQuantity: suggestion.orderQuantity,
                        caseQuantity: suggestion.caseQuantity,
                        eachQuantity: suggestion.eachQuantity,
                        product: allOptions[0]
                    });
                }
                this.onProductSuggestion({
                    productSuggestions: productSuggestions,
                    allProducts: allOptions,
                    errors: this.nullReplacement(response?.errors)
                });
            })
            .finally(() => {
                this.loading = false;
            });
    }

    nullReplacement(info) {
        if (!info || info.length === 0) {
            return;
        }

        for (const data of info) {
            for (const key in data) {
                if (data[key] instanceof String || typeof data[key] == 'string') {
                    data[key] = data[key].replace(/null/g, 'n/a');
                }
            }
        }
        return info;
    }
}
